export default __webpack_public_path__ + "static/media/PROCESSMETHOD_CASTING_INVESTMENT.aefce21e.png";